@if (filter.withSearch) {
  <div class="mb-1">
    <app-search-bar [settings]="searchSettings" (search)="onSearch($event)"></app-search-bar>
  </div>
}
@if (filter.withPagination) {
  <app-loader [loaderId]="loaderId" [fullPage]="false">
    <cdk-virtual-scroll-viewport [itemSize]="30" [minBufferPx]="200" [maxBufferPx]="250" class="viewport overflow mini">
      <div [uidGenerator]="'radio-'"
        *cdkVirtualFor="let item of filterOptions | async; trackBy: trackByIdx ; let index = index"
        class="item custom-control custom-radio">
        <input class="custom-control-input" type="radio" [value]="item.value"
          [checked]="filter.selected && filter.selected[0] && item.value === filter.selected[0].value"
          (change)="onChangeRadio(filter, item)" />
          <label style="max-width: 250px;" class="custom-control-label truncate"
          title="{{item.text | translate}}">{{item.text | translate}}</label>
        </div>
        @if (totalCount === filterOptions?.value?.length) {
          <div class="d-flex justify-content-center">
            <small>End data</small>
          </div>
        }
      </cdk-virtual-scroll-viewport>
      <div style="position: absolute; top:0; left:0; width:100%; height:100%; pointer-events:none"></div>
    </app-loader>
  }

  @if (!filter.withPagination) {
    <div class="radio-max-height overflow mini">
      @for (item of filterOptions | async; track item) {
        <div [uidGenerator]="'radio-'"
          class="custom-control custom-radio margin-bottom-small">
          <input class="custom-control-input" type="radio" [value]="item.value"
            [checked]="filter.selected && filter.selected[0] && item.value === filter.selected[0].value"
            (change)="onChangeRadio(filter, item)" />
            <label style="max-width: 250px;" class="custom-control-label truncate"
            title="{{item.text | translate}}">{{item.text | translate}}</label>
          </div>
        }
      </div>
    }
